(function(algolia) {
  'use strict';
  const render = algolia.externals.render;
  const html = algolia.externals.html;

  var algoliasearch = algolia.externals.algoliasearch;
  algolia.searchClient = algoliasearch(algolia.config.app_id, algolia.config.search_api_key);

  algolia.render = (template, container, data) => {
    return render(template(html, data), container);
  };

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price), discount_ratio = 1.0 - price_ratio, res = '';
    if (comparing) {
      res += ` <span class="ais-hit--price-striked"><span class="sr-only">Original Price</span><span>` + formatPrice(compare_at_price).replace('.00','') + `</span></span> `;
      res += `<b class="main_pric_with_com_price"><span class="sr-only">Current Price</span>` + formatPrice(price) + `</b>`;
    }
    else {
      res = `<span class="sr-only">Current Price</span><b>` + formatPrice(price).replace('.00','') + `</b>`;
    }
    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(val) {
      return Number(val).toLocaleString();
    },
    displayPrice: function displayPrice(item, distinct) {
      if (distinct) {
        var min = item.variants_min_price;
        var max = item.variants_max_price;
        if (min !== max) {
          return  formatPrice(min) + ' - ' + formatPrice(max);
        }
      }
      return formatPrice(item.price);
    },
    displayStrikedPrice: function displayStrikedPrice(price, compare_at_price) {
      const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
      if (comparing) { return formatPrice(compare_at_price) }
    },
    displayDiscount: function displayDiscount(price, compare_at_price, price_ratio) {
      const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
      const discount_ratio = 1.0 - price_ratio;
      if (comparing) { return `- ${Math.floor(discount_ratio * 100)} %`}
    },
    autocompletePrice: function autocompletePrice(hit) {
      if (hit._distinct) {
        var min = hit.variants_min_price;
        var max = hit.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min).replace('.00','') + ' - ' + formatPrice(max).replace('.00','') + '</b>';
        }
      }
      return formattedPriceWithComparison(hit.price, null);
    },
    autocompleteProductPrice: function autocompleteProductPrice(item){
      if (item._distinct) {
        var price = item.price;
        if (item.compare_at_price != null){
          if (item.price < item.compare_at_price) {
            return '<del>'+ formatPrice(item.compare_at_price).replace('.00','') +'</del><span class="autocomplete_compare_price">'+ formatPrice(item.price).replace('.00','') +'</span>';
          } else {
            if (item._distinct) {
              var min = item.variants_min_price;
              var max = item.variants_max_price;
              if (min !== max) {
                return formatPrice(min).replace('.00','') + ' - ' + formatPrice(max).replace('.00','');
              }
            }
          }
        } 
      }
      return formattedPriceWithComparison(item.price, null);
    },
    instantsearchPrice: function instantsearchPrice(hit) {
      if (hit._distinct) {
        var min = hit.variants_min_price;
        var max = hit.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min).replace('.00','') + ' - ' + formatPrice(max).replace('.00','') + '</b>';
        }
      }
      return formattedPriceWithComparison(
        hit.price,
        hit.compare_at_price,
        hit.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink(hit) {
      const addVariantId = !hit._distinct && hit.objectID !== hit.id;
      return (
        '/products/' +
        hit.handle +
        (addVariantId ? '?variant=' + hit.objectID : '')
      );
    },
    hoverImage: function hoverImage(hit) {
       var new_neta = hit.meta, hitImage = '';
       if (Object.keys(new_neta).length !== 0){
        var hoverimage = hit._distinct ? hit.meta.custom.hover_image : hit.image;
         if (!hoverimage) hitImage = 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
         hitImage = '<img class="hoveredImage" src="'+hoverimage+'" alt="'+hit.title+' - hoverimage">';
       }
       return hitImage;
    },
    addOverlayforsoldout: function addOverlayforsoldout(hit) {
      var new_tags = hit.tags, overlayClass = '';
      if (new_tags.indexOf('dontpublish') > -1 && hit.inventory_quantity == 0 && hit.inventory_policy == 'deny'){
        overlayClass = '<div class="dontPublishOverlay"><span>SOLD OUT</span></div>';
      }
      return overlayClass;
    },
    instantsizecoloroptions: function instantsizecoloroptions(hit) {
      var __this = hit;
      var tag = __this.tags;
      var current_tag = 'swatch_tag_' + __this.handle
      if(tag.indexOf(current_tag) > -1 ){
        $.get('/collections/all/'+current_tag+'?view=algolia_plp',function(data){
          var new_data =  data.split('[splitttt]');
          $('[data-variant-id="'+__this.objectID+'"] .swatch_wrap').html(new_data[0]);
          $('[data-variant-id="'+__this.objectID+'"] .ais-hit--color-count').html(new_data[1]);
          $('[data-variant-id="'+__this.objectID+'"] .quick_view_sizes').html(new_data[2]);

          // Change - DVUS - Promo Text Rounded UP
          const promoMessageElement = $('[data-variant-id="'+__this.objectID+'"]').find('.ais-hit--promo-message');
          const exists = promoMessageElement.length > 0;
          exists ? promoMessageElement.html(new_data[3]) : $('[data-variant-id="'+__this.objectID+'"]').find('.swatch_wrap').append('<div class="ais-hit--promo-message">'+new_data[3]+'</div>');
          // Change - DVUS - Promo Text Rounded UP
          
        }).error(function(event, jqxhr, exception) {
        });
      }
      else{
        $.get( '/products/'+__this.handle +'?view=color-swatch', function( data ) {
          var new_data =  data.split('[splitttt]');
          $('[data-variant-id="'+__this.objectID+'"] .ais-hit--color-count').html(new_data[1]);
          $('[data-variant-id="'+__this.objectID+'"] .quick_view_sizes').html(new_data[2]);
        }).error(function(event, jqxhr, exception) {
        });
      }
    },
    productbadge: function productbadge(hit) {
      var new_tags = hit.tags, tagHtml = '';
      if( hit.compare_at_price > hit.price ){
          let percentage = Math.trunc((hit.compare_at_price - hit.price) / hit.compare_at_price * 100);
          var finalPercentage = percentage % 5 === 0 ? percentage : Math.round(percentage / 10) * 10
          tagHtml = '<span class="new_product_badge ab_sale_badge">Sale</span><span class="new_product_badge ab_dis_sale_badge">'+ finalPercentage +'% OFF</span>'
      } else if(new_tags.indexOf('SELLINGFAST') > 1 ){
          tagHtml = '<span class="new_product_badge">SELLING FAST</span>'
      } else if(new_tags.indexOf('TOPRATED') > 1 ){
          tagHtml = '<span class="new_product_badge">TOP RATED</span>'
      } else if(new_tags.indexOf('BIS') > 1 ){
          tagHtml = '<span class="new_product_badge">BACK IN STOCK</span>'
      } else if(new_tags.indexOf('EXTENDEDCALF') > 1 || new_tags.indexOf('Extendedcalf') > 1 || new_tags.indexOf('extendedcalf') > 1 ){
          tagHtml = '<span class="new_product_badge">WIDE CALF</span>'
      } else if(new_tags.indexOf('EXCLUSIVE') > 1 || new_tags.indexOf('Exclusive') > 1 || new_tags.indexOf('exclusive') > 1 ){
          tagHtml = '<span class="new_product_badge">EXCLUSIVE</span>'
      } else if(new_tags.indexOf('new') > -1 || new_tags.indexOf('New') > 1 || new_tags.indexOf('NEW') > 1 ){
	      tagHtml = '<span class="new_product_badge">New</span>'
      } else if(new_tags.indexOf('best-seller') > 1 || new_tags.indexOf('Best-seller') > 1 || new_tags.indexOf('bestseller') > 1 || new_tags.indexOf('BESTSELLER') > 1 || new_tags.indexOf('best seller') > 1 || new_tags.indexOf('Best seller') > 1){
	      tagHtml = '<span class="new_product_badge">Best Seller</span>'
      } else if(new_tags.indexOf('WIDE') > 1 || new_tags.indexOf('Wide') > 1 || new_tags.indexOf('wide') > 1 ){
	      tagHtml = '<span class="new_product_badge">Wide</span>'
      } else if(new_tags.indexOf('WATERPROOF') > 1 || new_tags.indexOf('Waterproof') > 1 || new_tags.indexOf('waterproof') > 1 ){
	      tagHtml = '<span class="new_product_badge">Waterproof</span>'
      }
      return tagHtml;
    },
    fullTitle: function fullTitle(title, distinct, variant_title) {
      var res = title;
      if (
        !distinct &&
        variant_title &&
        variant_title !== 'Default Title' &&
        variant_title !== 'Default'
      ) {
        res += ' (' + variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle(hit) {
      var res = '';

      if (hit._highlightResult.title && hit._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          hit._highlightResult.title.value.toLowerCase()
        );
      }

      if (
        !hit._distinct &&
        hit.variant_title &&
        hit.variant_title !== 'Default Title' &&
        hit.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      if (res.includes('h2o') > -1){
        res = res.replace('h2o','H2O');
      }
      return res
    },
    variantTitleAddition: function variantTitleAddition(item, distinct) {
      var res = ' ';
      if (
        !distinct &&
        item.variant_title &&
        item.variant_title !== 'Default Title' &&
        item.variant_title !== 'Default'
      ) {
        res += `( ${item.variant_title} )`;
      }
      return res;
    },
    hexToRGB: function hexToRGB(hex){
      if (!hex) return ``;
      if(hex.length== 4){
        hex = hex.substring(1).replace(/./g, '$&$&')
      }
      var m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`;
    },
    sizedImage: function sizedImage(sizeInput, item, _distinct) {
      var image = _distinct ? item.product_image : item.image;
      if (!image) return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      
      var size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') return image;
      
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    index_suffix: (function () {
      const ALGOLIA_MARKET_KEY = 'algolia_market';
      let cache_suffix = '';
      let isMemoized = false;

      return async function memorizedIndexSuffix() {
        if (isMemoized) return cache_suffix;

        if (algolia.config.markets_indexing_enabled && algolia.config.markets_mapping?.length) {
          // Check if market has changed, if changed, update market
          let shouldCheckMarketIndex = true;
          try {
            const marketStorage = JSON.parse(localStorage.getItem(ALGOLIA_MARKET_KEY) || '{}');
            
            if (
              marketStorage.id == algolia.shopify.market.id && 
              marketStorage.locale == algolia.shopify.market.language.shop_locale.locale
            ) {
              cache_suffix = marketStorage.suffix ? `_${marketStorage.suffix}` : '';
              shouldCheckMarketIndex = false;
              isMemoized = true;
            } 
          } catch (e) {
            localStorage.removeItem(ALGOLIA_MARKET_KEY);
            cache_suffix = '';
            isMemoized =true;
          }
          
          if(shouldCheckMarketIndex) {
            try {
              // key = {market_id}_{market_language}
              const key = `${algolia.shopify.market.id}_${algolia.shopify.market.language.shop_locale.locale}`;
              const market = algolia.config.markets_mapping.find(market => market.key === key);
              if(market) {
                const indexSuffix = market.suffix ? `_${market.suffix}` : '';

                // indexName = {prefix}_{type}_{market_title}_{language_code}
                const indexName = `${algolia.config.index_prefix}products${indexSuffix}`;
                const index = algolia.searchClient.initIndex(indexName);

                await index.search({ analystics: false, page: 1, hitsPerPage: 1 })
                cache_suffix = indexSuffix;
                localStorage.setItem(ALGOLIA_MARKET_KEY, JSON.stringify(market));
                isMemoized = true;
              }
            } catch (e) {
              localStorage.removeItem(ALGOLIA_MARKET_KEY);
              cache_suffix = '';
              isMemoized = true;
            }
          }
          return cache_suffix;
        }
        else {
          return cache_suffix;
        }
      }
    })(),
  };

  algolia.config.index_suffix = algolia.helpers.index_suffix();

  ['pico', 'icon', 'thumb', 'small', 'compact', 'medium', 'large', 'grande', 'original'].forEach(function(size) {
    algolia.helpers[size + 'Image'] = function(item, _distinct){
        var image = _distinct ? item.product_image : item.image;
        if (!image) return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        if (size === 'original') return image;

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    };
  });
})(window.algoliaShopify);
